import type { GetUpdatesSource } from "~/feature/auth/type";

import { CiteEmbedTabEnum } from "./types";

export const CITE_EMBED_ACTION = {
  label: "Cite & embed",
  tooltip:
    "Cite or embed this event's PH Consensus. Credited to PredictionHero.",
};

export const CITE_EMBED_TITLE = "Cite & embed PH Consensus";

export const CITE_EMBED_TABS = [
  { value: CiteEmbedTabEnum.CITE, label: "Cite" },
  { value: CiteEmbedTabEnum.EMBED, label: "Embed" },
];

export const CITE_COPY = {
  citation: "Copy citation",
  link: "Copy link",
  copied: "Copied",
};

export const CITE_COPIED_MS = 2000;

export const EMBED_FORMAT = {
  chart: "Chart",
};

export const STAY_ON_TOP = {
  title: "Stay on top of this number",
  emailLabel: "Email for the newsletter",
  emailPlaceholder: "you@email.com",
  subscribe: "Subscribe to newsletter",
  sending: "Sending…",
  subscribed: "You're subscribed",
};

// Kit tags signups from this popup `src-cite-embed`, apart from the site button's.
export const NEWSLETTER_SOURCE: GetUpdatesSource = "cite_embed";

export const CITE_EMBED_FOOTER =
  "Weighted by trading volume across every platform listing this event. No platform pays for placement. PredictionHero is an independent data layer across every prediction market.";

export const METHODOLOGY_LABEL = "Methodology";
